import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { toQueryString } from "../clients/utils/url";
import { AuthStatus, useAuth } from "../context/AuthContext";
import { Routes } from "./routes";

interface PrivateRouteProps {
  children: React.ReactElement;
}

const PrivateRoute: React.FunctionComponent<PrivateRouteProps> = ({
  children
}) => {
  const { status } = useAuth();
  const location = useLocation();

  if (status === AuthStatus.LOGGED_IN) {
    return <>{children}</>;
  }

  const redirectTo = location.pathname + location.search;

  return (
    <Navigate
      to={{
        pathname: Routes.LOGIN,
        search: toQueryString({ redirectTo })
      }}
      replace
    />
  );
};

export { PrivateRoute };
